<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isEnd="isEnd" :isInnovation="true" :selectedQidSmall="selectedQidSmall" @getAnswer="getAnswer"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        title: '题目1',
        small: [
          {
            id: 1,
            title: '(1)',
            desc: ['（1）都有什么样的东西能当做浸种容器呢?请你在 5 分钟内，<span class="title_span">尽可能多</span>地列举出你想到的东西。'],
            durationTime: 5,
            stemContent: [
              // {
              //   type: 'text',
              //   value: '绿豆种子的发芽'
              // },
              {
                type: 'text',
                value: '绿豆种子发芽后，可以做成餐桌上常见的“炒豆芽”。如果能亲口品尝到自己发的豆芽，就太棒了!'
              },
              {
                type: 'img',
                value: require('@/assets/exam/13.png'),
                dontStats: true
              },
              {
                type: 'text',
                value: '<b>题目1：</b>绿豆种子先用水浸泡一段时间(浸种)，会更有助于它发芽。'
              },
              {
                type: 'img',
                value: require('@/assets/exam/lvdou.png'),
                dontStats: true
              },
              // {
              //   type: 'text',
              //   value: '小丽和妈妈一起用绿豆种子发豆芽，几天后，两人的豆芽生长出现了不同的情形。'
              // },
              // {
              //   type: 'text',
              //   value: '小丽发的豆芽，整体呈现绿色，叶子又大又绿，萎缩变小的豆瓣（子叶）呈粉红色。'
              // },
              // {
              //   type: 'text',
              //   value: '妈妈发的豆芽，整体呈现黄白色，叶子小而黄，稍稍萎缩的豆瓣无明显红色，而下部的芽又白、又长、又“胖”。'
              // },
              // {
              //   type: 'img',
              //   value: require('@/assets/exam/14.png')
              // }
            ],
            askList: [{
              id: 1,
              type: 4,
              config: {
                noneInput: true,
                type: 1
              }
            }]
          }, {
            id: 2,
            title: '(2)',
            durationTime: 3,
            desc: ['（2）请将你想到的浸种容器按类别拖拽到相应的分类框里，如果你想到的办法超出列出的这几类，可以点击“+”添加新的分类框。除了已经想到的这些，你能再想出新的浸种容器吗?请将新想法添加到相应的分类框中。'],
            stemContent: [
              {
                type: 'array'
              }
            ],
            askList: [{
              id: 1,
              type: 8,
              value: '类别',
              typeList: [
                {
                  title: '家居生活用品',
                  disabled: true,
                  children: []
                },
                {
                  title: '学习实验用具',
                  disabled: true,
                  children: []
                },
                // {
                //   title: '种子自身内在原因',
                //   disabled: true,
                //   children: []
                // }
              ]
            }]
          }
        ]
      }, {
        qid: 2,
        title: '题目2',
        small: [
          {
            id: 3,
            title: '(3)',
            durationTime: 5,
            desc: ['（3）绿豆浸种后，为了发好绿豆芽，小丽用了漏盆和湿布等材料(如左图)，你认为她的发芽装置有什么不足?请具体说明。'],
            stemContent: [
              {
                type: 'text',
                value: '<b>题目2：</b>要想让豆芽吃起来口感好，在发豆芽过程中需注意控制条件：定时给绿豆种子洒水、换水，保持湿润但不能被水浸泡；保持黑暗；气温不能过高或过低（通常20℃上下），这样发出的豆芽颜色偏白，又长又“胖”，叶片较小，吃起来又嫩又可口。'
              },
              {
                type: 'text',
                value: '如果发芽过程中受到阳光照射、气温过高，豆芽上部的叶子会很快伸展变绿，下部也会长出更多根须，吃起来又老又涩。'
              },
              {
                type: 'img',
                isSmall: true,
                value: [
                  { img: require('@/assets/exam/15.png'), showBigImg: true, imageKind: 'left#左图' },
                  { img: require('@/assets/exam/34.png'), showBigImg: true, imageKind: 'right#右图' }
                ]
              }
            ],
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
              isReview: true,
              title: ''
            }]
          },
          {
            id: 4,
            title: '(4)',
            durationTime: 5,
            desc: ['（4）请为小丽的装置提出改进建议，以便更好地控制发芽条件。请将你的改进想法，用画图和文字的方式进行说明。'],
            stemContent: [
              {
                type: 'text',
                value: '你发现的不足：'
              },
              {
                type: 'text',
                value: ''
              },
              {
                type: 'text',
                value: '小丽用的发芽装置：'
              },
              {
                type: 'img',
                isSmall: true,
                value: [
                  { img: require('@/assets/exam/15.png'), showBigImg: true, imageKind: 'left#左图' },
                  { img: require('@/assets/exam/34.png'), showBigImg: true, imageKind: 'right#右图' }
                ]
              }
            ],
            askList: [
              {
                id: 1,
                type: 10,
                title: '画图区：'
                // title: '画图区：可画在下发的答题纸上。'
              },
              {
                id: 1,
                type: 1,
                noneInput: true,
                title: '文字标注：'
              },
            ]
          },
        ]
      }, {
        qid: 3,
        title: '题目3',
        small: [
          {
            id: 5,
            title: '(5)',
            stemContent: [
              {
                type: 'text',
                value: '航天员尝试在空间站发豆芽，让未来漫长星际旅行的菜品更丰富。空间站长期处于<b>微重力环境</b>。请阅读下面的图文资料，并观看视频1、视频2，了解微重力环境。'
              },
              {
                type: 'img',
                value: require('@/assets/exam/16.png'),
                dontStats: true
              },
              {
                type: 'text',
                value: '【文字资料：空间站里的航天员能轻松漂浮在空中；水也不易向下流动，从装水袋中挤出的水，会以水珠的状态漂浮在空中。】'
              },
              {
                type: 'text',
                value: '视频1'
              },
              {
                id: 1,
                type: 'video',
                value: [
                  {
                    autoPlay: true,
                    isControl: true,
                    isloop: false,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/sprout_3_1_1.mp4',
                    videoNo: 1,
                  }
                ]
              },
              {
                type: 'text',
                value: '视频2'
              },
              {
                id: 2,
                type: 'video',
                value: [
                  {
                    autoPlay: false,
                    isControl: true,
                    isloop: false,
                    url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/sprout_3_1_2.mp4',
                    videoNo: 2,
                  }
                ],
              },
              {
                id: 2,
                type: 'text',
                value: '<b>题目3：</b>从地面带到空间站的绿豆种子，所处环境发生了很多变化，怎样能顺利发出豆芽呢？请发挥你的创意，设计太空发芽装置，这个创意希望是新颖的、独特的。'
              }
            ],
            showAnswer: false,
            durationTime: 5,
            desc: ['（5）请发挥你的想象力，设计一个太空发芽装置，且这个设计是其他同学不易想到的，请用画图和文字的方式清晰、具体地表达出来你的想法。'],
            askList: [
              {
                id: 1,
                type: 10,
                title: '画图区：'
                // title: '画图区：可画在下发的答题纸上。'
              },
              {
                id: 1,
                type: 1,
                isReview: true,
                noneInput: true,
                title: '文字标注：'
              },
            ],
          },
          {
            id: 6,
            title: '(6)',
            stemContent: [
              {
                type: 'text',
                value: '设计图：'
              },
              {
                type: 'draw',
                value: 'img'
              },
              {
                type: 'text',
                value: '文字标注：'
              },
              {
                type: 'text',
                value: ''
              },
            ],
            showAnswer: true,
            durationTime: 5,
            desc: ['（6）你的设计创意是从哪里受到启发的？请你具体说一说。'],
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
            }],
          }
        ]
      }],
      isEnd: false,
      loading: false,
      selectedQidSmall: 1
    }
  },
  methods: {
    getSmallList() {
      const list = this.qidList.reduce((list, item) => {
        list.push(...item.small)
        return list
      }, [])
      return list
    },
    getAnswer(obj) {
      const selectedQidSmall = obj.selectedQidSmall
      const smallList = this.getSmallList()
      const smallItem = smallList[selectedQidSmall]
      for (const item of smallItem.stemContent) {
        if (item.type == 'text' && item.value == '') {
          item.value = obj.text
        }
      }
      // this.qidList[1].small[1].stemContent[1].value = obj.text
      this.$forceUpdate()
    },
    async next(sonData, currentQSmall, type) {
      const num = currentQSmall % 2 === 1 ? 1 : 2
      const tab = Math.floor(currentQSmall / 2)
      const data = Object.assign({
        exam_id: 1,
        exam_num: (num === 1 ? tab + 1 : tab) + '_' + num,
        subject_id: 5,
        subject_name: '发豆芽',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (!this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 6) {
        this.selectedQidSmall = 6
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'innovationSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  },
  mounted() {
    // if (sessionStorage.selectedQidSmall) {
    //   const obj = JSON.parse(sessionStorage.selectedQidSmall)
    //   if (obj.sprout && Number(obj.sprout) > 1) {
    //     this.selectedQidSmall = Number(obj.sprout)
    //   } else {
    //     this.selectedQidSmall = 1
    //   }
    // } else {
    //   this.selectedQidSmall = 1
    // }
  }
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
